"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var fetch_1 = require("../utils/fetch");
var services_1 = require("../routes/services");
var lodash_1 = require("lodash");
exports.default = {
    checkoutPackage: function (_a) {
        var nonce = _a.nonce, pid = _a.pid;
        var _b = services_1.default.checkoutPackage, url = _b.url, method = _b.method;
        var newUrl = lodash_1.replace(url, "{pid}", pid);
        var body = JSON.stringify({ payment_method_nonce: nonce });
        return fetch_1.default(newUrl, {
            body: body,
            method: method,
        });
    },
    verifyAppleReceipt: function (_a) {
        var receipt = _a.receipt;
        var body = JSON.stringify({ receipt: receipt });
        return fetch_1.default("/apple-receipts", {
            body: body,
            method: "POST",
        });
    },
    getServiceInfo: function () {
        return fetch_1.default("/service", {
            method: "GET",
        });
    },
    subscribePlan: function (_a) {
        var nonce = _a.nonce, auto_renew = _a.auto_renew, planId = _a.planId;
        var _b = services_1.default.subscribePlan, url = _b.url, method = _b.method;
        var newUrl = lodash_1.replace(url, "{planId}", planId);
        var body = JSON.stringify({ payment_method_nonce: nonce, auto_renew: auto_renew });
        return fetch_1.default(newUrl, {
            body: body,
            method: method,
        });
    },
    sendInquiry: function (data) {
        var _a = services_1.default.sendInquiry, url = _a.url, method = _a.method;
        var body = JSON.stringify(data);
        return fetch_1.default(url, {
            body: body,
            method: method,
        });
    },
};
//# sourceMappingURL=services.js.map